
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SpacecraftMapConfigInterface, SpacecraftMapFollowSpacecraft } from "./spacecraftmap.types";
import { api } from "../../services/api";
import { IDataTLEs } from "../../services/api.types";

@Component
export default class SpacecraftMapConfigComponent extends Vue {
  @Prop() config!: SpacecraftMapConfigInterface
  AVAILABLE_SPACECRAFT: Array<string> = new Array<string>()

  created() {
    let subscr = api.sendResponse("data/tles", "")
      .subscribe((data: IDataTLEs) => {
        if (data) {
          subscr.unsubscribe()
          this.AVAILABLE_SPACECRAFT = data.tles.map(tle => tle[0].trim())
        }
      })
  }

  get availableSpacecraft(): Array<string> {
    return this.AVAILABLE_SPACECRAFT.concat(this.config.hasOwnProperty("spacecraft") ? this.config.spacecraft : [])
  }

  get enabledSpacecraft(): Array<string> {
    if (!this.config.spacecraft) {
      Vue.set(this.config, "spacecraft", ["ISS (ZARYA)", "CSS (TIANHE)"])
    }
    return this.config.spacecraft
  }
  set enabledSpacecraft(value: Array<string>) {
    this.config.spacecraft = value.slice(0, 5);
  }

  get followSpacecraft() {
    if (!this.config.followSpacecraft) {
      Vue.set(this.config, "followSpacecraft", {
        name: "ISS (ZARYA)",
        enabled: false
      })
    }
    return this.config.followSpacecraft
  }
  set followSpacecraft(value: SpacecraftMapFollowSpacecraft) {
    this.config.followSpacecraft = value
  }

  get followSpacecraftEnable() {
    return this.followSpacecraft.enabled;
  }
  set followSpacecraftEnable(value: boolean) {
    this.followSpacecraft = {
      ...this.followSpacecraft,
      enabled: value
    }
  }
  get followSpacecraftAvailable() {
    return this.enabledSpacecraft
  }

  get followSpacecraftName() {
    return this.followSpacecraft.name;
  }
  set followSpacecraftName(value: string) {
    this.followSpacecraft = {
      ...this.followSpacecraft,
      name: value
    }
  }

  @Watch("config")
  onConfigChange(value: SpacecraftMapConfigInterface) {
    this.$emit("update:config", value);
  }
}
